<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-5.6-9.9c-.387 0-.7.403-.7.9s.313.9.7.9h11.2c.387 0 .7-.403.7-.9s-.313-.9-.7-.9H6.4z" fill="#7A7A7A"/>
  </svg>
</template>

<script>
export default {
  name: "DocumentationIncompleteIcon"
}
</script>